import { LoaderCircle } from "lucide-react";
import { Wordmark } from "@/components/shell/logo";

/** Branded full-screen loader for the first chunk load and auth hand-offs. */
export function AuthLoadingScreen({
  subtitle = "One moment",
}: {
  subtitle?: string;
}) {
  return (
    <div
      role="status"
      aria-live="polite"
      className="flex min-h-dvh flex-col items-center justify-center bg-background px-6 text-center"
    >
      <Wordmark className="mb-8 text-ink" size="lg" />
      <p className="mb-6 text-sm text-ink-3">{subtitle}</p>
      <LoaderCircle
        className="size-5 animate-spin motion-reduce:animate-none text-ink-3"
        aria-hidden="true"
      />
    </div>
  );
}
